import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderTemplatesFacade } from 'src/app/extensions/order-templates/facades/order-templates.facade';
import { OrderTemplate } from 'src/app/extensions/order-templates/models/order-template/order-template.model';

import { SkuQuantityType } from 'ish-core/models/product/product.model';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

type OrderTemplateColumnsType = 'title' | 'creationDate' | 'lineItems' | 'actions';

@Component({
  selector: 'custom-quickorder-order-template-list',
  templateUrl: './custom-quickorder-order-template-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomQuickorderOrderTemplateListComponent {
  readonly orderTemplates = input<OrderTemplate[]>(undefined);
  readonly columnsToDisplay = input<OrderTemplateColumnsType[]>(['title', 'creationDate', 'lineItems', 'actions']);
  constructor(private orderTemplatesFacade: OrderTemplatesFacade, private translate: TranslateService) {}

  /** Emits the id of the order template to delete. */
  delete(orderTemplateId: string) {
    this.orderTemplatesFacade.deleteOrderTemplate(orderTemplateId);
  }

  /** Determine the heading of the delete modal and opens the modal. */
  openDeleteConfirmationDialog(orderTemplate: OrderTemplate, modal: ModalDialogComponent<string>) {
    modal.options().titleText = this.translate.instant('account.order_templates.delete_dialog.header', {
      0: orderTemplate.title,
    });
    modal.show(orderTemplate.id);
  }

  getParts(template: OrderTemplate): SkuQuantityType[] {
    return template?.items.map(item => ({ sku: item.sku, quantity: item.desiredQuantity.value }));
  }
}
